export default {"src":"/_next/static/media/logo.a795e14a.svg","height":28,"width":155,"blurWidth":0,"blurHeight":0};